import request from '@/utils/request'

function findAllByStoreId (storeId) {
  return request({
    url: `/pos/paymentTool?storeId=${storeId}`,
    method: 'get'
  })
}

export default {
  findAllByStoreId
}
